import { render } from "./loginComponent.vue?vue&type=template&id=6b8328a0&scoped=true"
import script from "./loginComponent.vue?vue&type=script&lang=js"
export * from "./loginComponent.vue?vue&type=script&lang=js"

import "./loginComponent.vue?vue&type=style&index=0&id=6b8328a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b8328a0"]])

export default __exports__